import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const ManageUserService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/manageuser/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    getUser: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/manageuser/get", { id }, successCallback, failureCallback);
    },
    saveUser: (vo, successCallback, failureCallback) => {
        var passwordHash = "";
        if (!Helper.isNullOrEmpty(vo.password)) {
            let sha256 = require("crypto-js/sha256");
            passwordHash = sha256(vo.password).toString();
        }

        ApiService.post("/web/admin/manageuser/save", { ...vo, password: passwordHash }, successCallback, failureCallback);
    },
    deleteUser: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/manageuser/delete", { id }, successCallback, failureCallback);
    },
    deleteUsers: (ids, successCallback, failureCallback) => {
        ApiService.post("/web/admin/manageuser/deleteusers", { ids }, successCallback, failureCallback);
    },
    recoverUser: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/manageuser/recoveruser", { id }, successCallback, failureCallback);
    },
    upload: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Users");
        formData.append("field", "Photo");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },

    extendVipTime: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/manageuser/extendviptime", vo, successCallback, failureCallback);
    },
    loginUserForSuperAdmin:(memberId, type, successCallback, failureCallback)=>{
        ApiService.get(`/web/admin/manageuser/loginUser?id=${memberId}&type=${type}`,null, successCallback, failureCallback);
    },
    loginTeacherForAdmin:(teacherId, successCallback, failureCallback)=>{
        ApiService.get(`/web/admin/manageuser/loginTeacher?id=${teacherId}`,null, successCallback, failureCallback);
    },
    loginAgentForAdmin:(agentId, successCallback, failureCallback)=>{
        ApiService.get(`/web/admin/manageuser/loginAgent?id=${agentId}`,null, successCallback, failureCallback);
    },
    loginTeacherForAgent:(teacherId, successCallback, failureCallback)=>{
        ApiService.get(`/web/admin/manageuser/loginTeacherForAgent?id=${teacherId}`,null, successCallback, failureCallback);
    },
    loginManagerForTeacher:(partnerId, id, successCallback, failureCallback)=>{
        ApiService.get(`/web/admin/manageuser/loginManagerForTeacher?partnerId=${partnerId}&id=${id}`,null, successCallback, failureCallback);
    },
};

export default ManageUserService;
